import React from 'react';
import { IonContent, IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonBackButton, IonSelect, IonSelectOption } from '@ionic/react';
import { useTranslation } from 'react-i18next';

const ConditionsGenerales: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const handleLanguageChange = (event: CustomEvent) => {
    const newLanguage = event.detail.value;
    i18n.changeLanguage(newLanguage);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>{t('terms.title')}</IonTitle>
          <IonButtons slot="end">
            <IonSelect
              value={currentLanguage}
              onIonChange={handleLanguageChange}
              interface="popover"
              className="px-2"
            >
              <IonSelectOption value="fr">Français</IonSelectOption>
              <IonSelectOption value="en">English</IonSelectOption>
              <IonSelectOption value="ru">Русский</IonSelectOption>
            </IonSelect>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl font-bold mb-6">{t('terms.title')}</h1>
          
          <p className="text-sm text-gray-600 mb-8">
            {t('terms.lastUpdated')}: {new Date().toLocaleDateString()}
          </p>

          {Object.keys(t('terms.sections', { returnObjects: true })).map((sectionKey) => (
            <section key={sectionKey} className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {t(`terms.sections.${sectionKey}.title`)}
              </h2>
              <p className="mb-4">
                {t(`terms.sections.${sectionKey}.content`)}
              </p>
            </section>
          ))}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ConditionsGenerales;
